import { render, staticRenderFns } from "./businessDetail.vue?vue&type=template&id=73c3c9b9&scoped=true&"
import script from "./businessDetail.vue?vue&type=script&lang=js&"
export * from "./businessDetail.vue?vue&type=script&lang=js&"
import style0 from "./businessDetail.vue?vue&type=style&index=0&id=73c3c9b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c3c9b9",
  null
  
)

export default component.exports